<div class="popup-overlay modal-confirm confiram-fail">
  <div class="popup-warp">
      <div class="popup-inner pad-popup">
          <div class="content-popup">
              <div class="icon-popup"><img src="assets/img/unilever-icon.png"></div>
              <p class="des-popup" [innerHtml]="message|safeHtml"></p>
              <div class="group-btn-inline btn-center">
                  <button type="button" class="btn btn-confirm" id="close-modal" (click)="closePopupHandle()">Đóng</button>
              </div>
          </div>
      </div>
  </div>
</div>